import { UniAnswer } from "../../dao/UniAnswer";
import { ExportBundle } from "../../export_spwk/ExportBundle";
import { HisDto } from "../../export_spwk/HisDtoManager/HisDto";

/**
 * 此畫面轉檔結果資料結構，方便顯示在畫面上用的
 */

export enum FinishStatus {
  Unknown = '未知', // 表示狀態未知
  Success = '成功', // 表示操作成功完成
  Warning = '警告', // 表示操作完成，但有一些警告需要處理
  Error = '錯誤',   // 表示操作失敗，需要處理錯誤
}


export class SpwkToHisInfo {

  /** 對應哪個 UniAnswer.guid */
  ANSWER_GUID: string;

  /** 對應哪個 UniAnswer */
  Ans: UniAnswer;

  //#region 中繼檔 轉換結果
  /** 第一次中繼檔格式時的結果，失敗會是 null */
  ExportBundle: ExportBundle | null = null;

  /** 中繼檔 警告訊息 */
  ExportBundle_WarningList: string[] = [];

  /** 中繼檔 錯誤警告訊息 */
  ExportBundle_ErrorList: string[] = [];
  //#endregion

  //#region HisDto 院內API格式轉換結果
  /** 資訊 API 用的格式，由 ExportBundle(xls格式) 稍微做轉換合併得到 */
  HisDto: HisDto | null = null;

  /** HisDto 警告訊息 */
  HisDto_WarningList: string[] = [];

  /** HisDto 錯誤警告訊息 */
  HisDto_ErrorList: string[] = [];
  //#endregion



  /** 判斷中繼檔是否有正確轉換 */
  get_ExportBundle_FinishStatus() {
    if (this.ExportBundle == null || this.ExportBundle_ErrorList.length !== 0) {
      return FinishStatus.Error;
    } else if (this.ExportBundle_WarningList.length !== 0) {
      return FinishStatus.Warning;
    } else if (this.ExportBundle != null) {
      return FinishStatus.Success;
    } else {
      return FinishStatus.Unknown;
    }
  };

  /** 判斷中繼檔是否有正確轉換 */
  get_HisDto_FinishStatus() {
    if (this.HisDto == null || this.HisDto_ErrorList.length !== 0) {
      return FinishStatus.Error;
    } else if (this.HisDto_WarningList.length !== 0) {
      return FinishStatus.Warning;
    } else if (this.HisDto != null) {
      return FinishStatus.Success;
    } else {
      return FinishStatus.Unknown;
    }
  };


  /** 列出錯誤訊息 */
  get_ExportBundle_ErrorWarningMessage() {
    let re = "";
    if (this.ExportBundle_ErrorList.length !== 0) {
      re += "[錯誤]";
      re += this.ExportBundle_ErrorList.join("\n");
    }

    if (this.ExportBundle_WarningList.length !== 0) {
      re += "[警告]";
      re += this.ExportBundle_WarningList.join("\n");
    }

    return re;
  }

  /** 列出錯誤訊息 */
  get_HisDto_ErrorWarningMessage() {
    let re = "";
    if (this.HisDto_ErrorList.length !== 0) {
      re += "[錯誤]";
      re += this.HisDto_ErrorList.join("\n");
    }

    if (this.HisDto_WarningList.length !== 0) {
      re += "[警告]";
      re += this.HisDto_WarningList.join("\n");
    }

    return re;
  }



  constructor(ans: UniAnswer) {
    this.ANSWER_GUID = ans.guid;
    this.Ans = ans;
  }

}